import { Col, InputNumber, Row, Slider } from 'antd';
import type { FC } from 'react';

type Props = {
  label: React.ReactNode;
  value: number;
  onChange: (count: number) => void;
  max: number;
  min: number;
  step: number;
};

export const RangeCountForm: FC<Props> = ({ label, value, onChange, max, min, step }) => {
  return (
    <>
      <Row>{label}</Row>

      <Row style={{ marginBottom: '1rem', marginTop: '0.5rem' }} align="middle">
        <Col sm={19}>
          <Slider value={value} min={min} max={max} step={step} onChange={onChange} />
        </Col>
        <Col offset={1} sm={4}>
          <InputNumber
            value={value}
            min={min}
            max={max}
            step={step}
            onChange={(value) => onChange(value || 0)}
            type="number"
          />
        </Col>
      </Row>
    </>
  );
};
